import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import Icon from './Icon'; // تأكد من استيراد المكون المصحح

const styles: { [key: string]: React.CSSProperties } = {
  alert: {
    padding: '15px',
    marginBlock: '20px',
    border: '1px solid transparent',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  error: {
    color: '#a94442',
    backgroundColor: '#f2dede',
    borderColor: '#ebccd1',
  },
  icon: {
    fontSize: '20px',
  },
  message: {
    margin: 0,
    fontWeight: 'bold',
  }
};

interface ErrorAlertProps {
  message: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message }) => {
  return (
    <div style={{ ...styles.alert, ...styles.error }} role="alert">
        {/* لاحظ التغيير هنا */}
       <Icon as={FaExclamationCircle} style={styles.icon} />
      <p style={styles.message}>{message}</p>
    </div>
  );
};

export default ErrorAlert;
